"use client";

import { useEffect, useState } from "react";
import { getViewAsTenantName, clearViewAsTenant } from "./TenantSwitcher";
import { BRAND } from "@/lib/theme/palette";

/**
 * Banner displayed when a super_admin is viewing as a tenant.
 * Reads from the rf_view_as_tenant_name cookie.
 */
export function ViewingAsBanner(): React.JSX.Element | null {
  const [tenantName, setTenantName] = useState<string | null>(null);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- read cookie on mount
    setTenantName(getViewAsTenantName());
  }, []);

  if (!tenantName) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        height: 36,
        background: BRAND.highlight,
        color: BRAND.ink,
        fontSize: 13,
        fontWeight: 600,
      }}
    >
      <span>
        Viewing as: <strong>{tenantName}</strong>
      </span>
      <button
        type="button"
        onClick={clearViewAsTenant}
        style={{
          padding: "2px 12px",
          background: BRAND.ink,
          color: "#ffffff",
          border: "none",
          borderRadius: 4,
          fontSize: 12,
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Return to Admin
      </button>
    </div>
  );
}
